import React from 'react';
import styled from '@emotion/styled';

import * as Icons from './systemIcons/index';
import { css, keyframes } from '@emotion/react';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  borderRadius?: number,
  className?: string,
  fill: string,
  name: string,
  onClick?: Function,
  size?: number | string,
  spin?: boolean,
  title?: string,
  verticalAlign?: 'top' | 'middle' | 'bottom',
};

export const IconsList = {
  Accessibility: Icons.Accessibility,
  ArrowDown: Icons.ArrowDown,
  ArrowLeft: Icons.ArrowLeft,
  ArrowRight: Icons.ArrowRight,
  ArrowUpRightFromSquare: Icons.ArrowUpRightFromSquare,
  Bag: Icons.Bag,
  BagFrown: Icons.BagFrown,
  Bars: Icons.Bars,
  Calendar: Icons.Calendar,
  Camera: Icons.Camera,
  Card: Icons.Card,
  Check: Icons.Check,
  CheckCircle: Icons.CheckCircle,
  CheckCircleOutline: Icons.CheckCircleOutline,
  CheckSquare: Icons.CheckSquare,
  ChevronDown: Icons.ChevronDown,
  ChevronLeft: Icons.ChevronLeft,
  ChevronRight: Icons.ChevronRight,
  ChevronUp: Icons.ChevronUp,
  Circle: Icons.Circle,
  CircleHalf: Icons.CircleHalf,
  Clock: Icons.Clock,
  Clone: Icons.Clone,
  Comp: Icons.Comp,
  CrossCircle: Icons.CrossCircle,
  Crown: Icons.Crown,
  Deliveroo: Icons.Deliveroo,
  Delivery: Icons.Delivery,
  Diamond: Icons.Diamond,
  Dislike: Icons.Dislike,
  DislikeStroke: Icons.DislikeStroke,
  DotCircle: Icons.DotCircle,
  EatIn: Icons.EatIn,
  EatInV2: Icons.EatInV2,
  EdenredLogo: Icons.EdenredLogo,
  Email: Icons.Email,
  Envelope: Icons.Envelope,
  ExclamationCircleOutline: Icons.ExclamationCircleOutline,
  Eye: Icons.Eye,
  EyeSlash: Icons.EyeSlash,
  Filter: Icons.Filter,
  Gift: Icons.Gift,
  HappySmiley: Icons.HappySmiley,
  Heart: Icons.Heart,
  HexagonBadgeFilters: Icons.HexagonBadgeFilters,
  Home: Icons.Home,
  HomeChimneys: Icons.HomeChimneys,
  Info: Icons.Info,
  InfoBordered: Icons.InfoBordered,
  InfoCircle: Icons.InfoCircle,
  Kiosk: Icons.Kiosk,
  Language: Icons.Language,
  LeafSolid: Icons.LeafSolid,
  Like: Icons.Like,
  LikeStroke: Icons.LikeStroke,
  List: Icons.List,
  Loader: Icons.Loader,
  Location: Icons.Location,
  MapMarker: Icons.MapMarker,
  MapMarker2: Icons.MapMarker2,
  MapMarkerOutline: Icons.MapMarkerOutline,
  Medal: Icons.Medal,
  Minus: Icons.Minus,
  Mobile: Icons.Mobile,
  MoneyBill: Icons.MoneyBill,
  OfflineInternet: Icons.OfflineInternet,
  OpatPartial: Icons.OpatPartial,
  OpatSplit: Icons.OpatSplit,
  Pencil: Icons.Pencil,
  Pepper: Icons.Pepper,
  Phone: Icons.Phone,
  Plus: Icons.Plus,
  PlusCircle: Icons.PlusCircle,
  Pointer: Icons.Pointer,
  Printer: Icons.Printer,
  Profile: Icons.Profile,
  QRCode: Icons.QRCode,
  Receipt: Icons.Receipt,
  ReceiptSolid: Icons.ReceiptSolid,
  Rocket: Icons.Rocket,
  RocketOutline: Icons.RocketOutline,
  SadSmiley: Icons.SadSmiley,
  Sale: Icons.Sale,
  Search: Icons.Search,
  ShoppingCart: Icons.ShoppingCart,
  ShoppingCartOutline: Icons.ShoppingCartOutline,
  SignOut: Icons.SignOut,
  Spinner: Icons.Spinner,
  Square: Icons.Square,
  Star: Icons.Star,
  StarStroke: Icons.StarStroke,
  StoreSlash: Icons.StoreSlash,
  TabletScreen: Icons.TabletScreen,
  Takeaway: Icons.Takeaway,
  TextHeight: Icons.TextHeight,
  Times: Icons.Times,
  TimesBold: Icons.TimesBold,
  TimesCircle: Icons.TimesCircle,
  Trash: Icons.Trash,
  Trophy: Icons.Trophy,
  Undo: Icons.Undo,
  User: Icons.User,
  WarningCircle: Icons.WarningCircle,
  WarningTriangle: Icons.WarningTriangle,
};

export const _Icon = ({
  borderRadius,
  className,
  fill,
  name,
  onClick,
  size,
  spin,
  title,
  verticalAlign,
}: Props) => {
  const Component = IconsList[name];

  return Component ? (
    <StyledIcon
      as={Component}
      borderRadius={borderRadius}
      className={className}
      dataTest={name}
      fill={fill}
      onClick={onClick}
      size={size}
      spin={spin}
      title={title}
      verticalAlign={verticalAlign}
    />
  ) : null;
};

export const Icon = withSpacingStyles(_Icon);

const spinner = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const spinAnimation = css`
  animation: ${spinner} 0.75s linear infinite;
`;

const StyledIcon = styled.svg`
  ${({ spin }) => spin && spinAnimation};
  will-change: ${({ spin }) => spin && 'transform'};
  font-size: ${({ size }) => (typeof size === 'number' ? `${size}px` : size)};
  ${({ verticalAlign }) => verticalAlign && `vertical-align: ${verticalAlign}`}
`;

Icon.defaultProps = {
  fill: 'currentColor',
};
